module.exports = __webpack_public_path__ + "static/media/stotts.35737566.png";